import { fromJS } from 'immutable';


export const CLEAR_EDIT_VOLCANO_LOCATION = 'CLEAR_EDIT_VOLCANO_LOCATION';

export const GET_EDIT_VOLCANO_LOCATION_REQUEST = 'GET_EDIT_VOLCANO_LOCATION_REQUEST';
export const GET_EDIT_VOLCANO_LOCATION_SUCCESS = 'GET_EDIT_VOLCANO_LOCATION_SUCCESS';
export const GET_EDIT_VOLCANO_LOCATION_FAILURE = 'GET_EDIT_VOLCANO_LOCATION_FAILURE';

export const UPDATE_VOLCANO_LOCATION_REQUEST = 'UPDATE_VOLCANO_LOCATION_REQUEST';
export const UPDATE_VOLCANO_LOCATION_SUCCESS = 'UPDATE_VOLCANO_LOCATION_SUCCESS';
export const UPDATE_VOLCANO_LOCATION_FAILURE = 'UPDATE_VOLCANO_LOCATION_FAILURE';

export const CREATE_VOLCANO_LOCATION_REQUEST = 'CREATE_VOLCANO_LOCATION_REQUEST';
export const CREATE_VOLCANO_LOCATION_SUCCESS = 'CREATE_VOLCANO_LOCATION_SUCCESS';
export const CREATE_VOLCANO_LOCATION_FAILURE = 'CREATE_VOLCANO_LOCATION_FAILURE';

export const GET_EDIT_VOLCANO_LOCATION_COUNTRY_REQUEST = 'GET_EDIT_VOLCANO_LOCATION_COUNTRY_REQUEST';
export const GET_EDIT_VOLCANO_LOCATION_COUNTRY_SUCCESS = 'GET_EDIT_VOLCANO_LOCATION_COUNTRY_SUCCESS';
export const GET_EDIT_VOLCANO_LOCATION_COUNTRY_FAILURE = 'GET_EDIT_VOLCANO_LOCATION_COUNTRY_FAILURE';

export const GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_REQUEST = 'GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_REQUEST';
export const GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_SUCCESS = 'GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_SUCCESS';
export const GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_FAILURE = 'GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_FAILURE';

export const GET_EDIT_VOLCANO_LOCATION_STATUS_REQUEST = 'GET_EDIT_VOLCANO_LOCATION_STATUS_REQUEST';
export const GET_EDIT_VOLCANO_LOCATION_STATUS_SUCCESS = 'GET_EDIT_VOLCANO_LOCATION_STATUS_SUCCESS';
export const GET_EDIT_VOLCANO_LOCATION_STATUS_FAILURE = 'GET_EDIT_VOLCANO_LOCATION_STATUS_FAILURE';

export const GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST = 'GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST';
export const GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_SUCCESS = 'GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_SUCCESS';
export const GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_FAILURE = 'GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_FAILURE';

export const GET_EDIT_VOLCANO_LOCATION_LOCATION_REQUEST = 'GET_EDIT_VOLCANO_LOCATION_LOCATION_REQUEST';
export const GET_EDIT_VOLCANO_LOCATION_LOCATION_SUCCESS = 'GET_EDIT_VOLCANO_LOCATION_LOCATION_SUCCESS';
export const GET_EDIT_VOLCANO_LOCATION_LOCATION_FAILURE = 'GET_EDIT_VOLCANO_LOCATION_LOCATION_FAILURE';

export const EDIT_VOLCANO_LOCATION_OPEN_CONFIRMATION = 'EDIT_VOLCANO_LOCATION_OPEN_CONFIRMATION';
export const EDIT_VOLCANO_LOCATION_CANCEL_CONFIRMATION = 'EDIT_VOLCANO_LOCATION_CANCEL_CONFIRMATION';

export const GET_EDIT_VOLCANO_LOCATION_REGION_REQUEST = 'GET_EDIT_VOLCANO_LOCATION_REGION_REQUEST';
export const GET_EDIT_VOLCANO_LOCATION_REGION_SUCCESS = 'GET_EDIT_VOLCANO_LOCATION_REGION_SUCCESS';
export const GET_EDIT_VOLCANO_LOCATION_REGION_FAILURE = 'GET_EDIT_VOLCANO_LOCATION_REGION_FAILURE';

const initialState = fromJS({
  fetched: false,
  volcano: {},
  updating: false,

  fetchedCountries: false,
  countries: [],

  fetchedRegions: false,
  regions: [],

  fetchedMorphologies: false,
  morphologies: [],
  fetchedStatuses: false,
  statuses: [],
  fetchedEruptionTimes: false,
  eruptionTimes: [],
  fetchedLocations: false,
  locations: [],

  formData: {},
  editConfirmationOpen: false,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const volcanoLocationEditReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_EDIT_VOLCANO_LOCATION:
      return initialState;

    case EDIT_VOLCANO_LOCATION_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        editConfirmationOpen: true,
      }));
    case EDIT_VOLCANO_LOCATION_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        editConfirmationOpen: false,
      }));


    case GET_EDIT_VOLCANO_LOCATION_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));
    case UPDATE_VOLCANO_LOCATION_REQUEST:
    case CREATE_VOLCANO_LOCATION_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: true,
      }));
    case UPDATE_VOLCANO_LOCATION_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        volcano: action.response,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case CREATE_VOLCANO_LOCATION_SUCCESS:
    case GET_EDIT_VOLCANO_LOCATION_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        volcano: action.response,
        updating: false,
      }));
    case UPDATE_VOLCANO_LOCATION_FAILURE:
    case CREATE_VOLCANO_LOCATION_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_VOLCANO_LOCATION_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));

    case GET_EDIT_VOLCANO_LOCATION_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case GET_EDIT_VOLCANO_LOCATION_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case GET_EDIT_VOLCANO_LOCATION_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));

    case GET_EDIT_VOLCANO_LOCATION_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case GET_EDIT_VOLCANO_LOCATION_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case GET_EDIT_VOLCANO_LOCATION_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    case GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_REQUEST:
      return state.merge(fromJS({
        fetchedMorphologies: false,
      }));
    case GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_SUCCESS:
      return state.merge(fromJS({
        fetchedMorphologies: true,
        morphologies: action.response.items,
      }));
    case GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_FAILURE:
      return state.merge(fromJS({
        fetchedMorphologies: true,
      }));

    case GET_EDIT_VOLCANO_LOCATION_STATUS_REQUEST:
      return state.merge(fromJS({
        fetchedStatuses: false,
      }));
    case GET_EDIT_VOLCANO_LOCATION_STATUS_SUCCESS:
      return state.merge(fromJS({
        fetchedStatuses: true,
        statuses: action.response.items,
      }));
    case GET_EDIT_VOLCANO_LOCATION_STATUS_FAILURE:
      return state.merge(fromJS({
        fetchedStatuses: true,
      }));

    case GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST:
      return state.merge(fromJS({
        fetchedEruptionTimes: false,
      }));
    case GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_SUCCESS:
      return state.merge(fromJS({
        fetchedEruptionTimes: true,
        eruptionTimes: action.response.items,
      }));
    case GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_FAILURE:
      return state.merge(fromJS({
        fetchedEruptionTimes: true,
      }));

    case GET_EDIT_VOLCANO_LOCATION_LOCATION_REQUEST:
      return state.merge(fromJS({
        fetchedLocations: false,
      }));
    case GET_EDIT_VOLCANO_LOCATION_LOCATION_SUCCESS:
      return state.merge(fromJS({
        fetchedLocations: true,
        locations: action.response.items,
      }));
    case GET_EDIT_VOLCANO_LOCATION_LOCATION_FAILURE:
      return state.merge(fromJS({
        fetchedLocations: true,
      }));

    default:
      return state;
  }
};
